import React from "react";

const Collapsible = ({ title, instructions, children }) => (
  <details open className="collapsible">
    <summary>
      <div>{title}</div>
      <div className="collapsible-instructions-container">
        {instructions && <span className="collapsible-instructions-text">{instructions}</span>}
        <i className="fa-solid fa-caret-up fa-2xl" />
      </div>
    </summary>
    {children}
  </details>
);

export default Collapsible;
